// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimelineEventPart  {
    _originalTypeClassName = "Loom.BO.TimelineEventPart";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimelineEventPart.translate = translateService;
}
this.display = null;
this.highlight = false;
this.tooltip = null;
this.TimelineEventPartKey = null;
this._key = this.TimelineEventPartKey = 0; 
}

static translate: TranslateService;
_key: any;
display:any;
highlight:any;
tooltip:any;
private _TimelineEventPartKey:any;
get TimelineEventPartKey(): any {
    return this._TimelineEventPartKey;
  }
set TimelineEventPartKey(value: any) {
    this._TimelineEventPartKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TimelineEventPartKey == null || $this.TimelineEventPartKey == 0;
            }


}